import { AuthActions } from "../LoginRedux/Action";
import { StatCheckerActions } from "./action";

let cancelOrderState = {
  statData: null,
  statError: null,
  checkerDashboardData: null,
  checkerDashboardError: null,
};

export const statCheckerReducer = (
  state = cancelOrderState,
  { type, payload }
) => {
  switch (type) {
    case StatCheckerActions.STAT_CHECKER_SUCCESS:
      return {
        ...state,
        statData: payload,
        statError: null,
      };

    case StatCheckerActions.STAT_CHECKER_FAILURE:
      return {
        ...state,
        statData: null,
        statError: payload,
      };

    case StatCheckerActions.CHECKER_DASHBOARD_SUCCESS:
      return {
        ...state,
        checkerDashboardData: payload,
        checkerDashboardError: null,
      };

    case StatCheckerActions.CHECKER_DASHBOARD_FAILURE:
      return {
        ...state,
        checkerDashboardData: null,
        checkerDashboardError: payload,
      };

    case AuthActions.Logout_User:
      return {
        statData: null,
        statError: null,
        checkerDashboardData: null,
        checkerDashboardError: null,
      };
    default:
      return state;
  }
};
